<template>
  <v-navigation-drawer
    :value="show && !!selectedCompany"
    @input="toggleShow"
    class="sidebar-six"
    dark
    :style="{
      backgroundColor: appBarColor,
    }"
    height="100%"
    width="280px"
    :mobile-breakpoint="960"
    :floating="true"
    app
    style="z-index: 50"
  >
    <div
      class="ps d-flex flex-column"
      style="height: 100%"
      :style="{
        backgroundColor: appBarColor,
      }"
    >
      <div class="top-toolbar text-center">
        <div class="pa-5 top-toolbar text-center">
          <router-link to="/">
            <img height="50" src="/img/logo/logo-dark.png" alt="" />
          </router-link>
        </div>
        <div class="mb-4 mx-4">
          <v-menu
            v-model="showMenu"
            rounded="0 b-lg"
            offset-y
            eager
            z-index="50"
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                class="pa-3 rounded-lg white--text d-flex space-between"
                :style="{
                  backgroundColor: adjustBrightness(appBarColor, 20),
                }"
                :class="{
                  'rounded-b-0': showMenu,
                }"
              >
                <div
                  v-if="selectedCompany"
                  class="flex-1 d-flex align-center gap-2"
                >
                  <base-avatar
                    :seed="selectedCompany.id"
                    :size="35"
                    avatarStyle="glass"
                    color="secondary lighten-2"
                  />
                  <div>
                    <p
                      class="subtitle-1 mb-0 text-capitalize font-weight-black"
                      style="line-height: 1.3rem"
                    >
                      {{ selectedCompany.name }}
                    </p>
                  </div>
                </div>
                <div v-else class="flex-1 d-flex align-center gap-2">
                  No Company Selected
                </div>
                <v-icon right>mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-list
              :style="{
                backgroundColor: adjustBrightness(appBarColor, 20),
              }"
              color="text--white py-0"
            >
              <vue-perfect-scrollbar
                :settings="{ suppressScrollX: true, wheelPropagation: false }"
                class="ps flex-grow-1"
                style="max-height: 300px; max-width: 248px"
              >
                <v-list-item
                  dark
                  v-for="(item, index) in companiesFiltered"
                  :key="index"
                  @click="selectComp(item.id)"
                >
                  <!-- <v-list-item-content> -->
                  <div
                    class="d-flex align-center gap-3"
                    style="max-width: 100%"
                  >
                    <base-avatar
                      :seed="item.id"
                      :size="25"
                      avatarStyle="glass"
                      color="secondary lighten-2"
                    />
                    <span class="text-truncate text-16">
                      {{ item.name }}
                    </span>
                  </div>
                  <!-- </v-list-item-content> -->
                </v-list-item>
              </vue-perfect-scrollbar>
            </v-list>
          </v-menu>
          <v-btn
            v-if="hasUltimatePermission('*')"
            @click="goToUltimate"
            color="primary"
            small
            block
            depressed
            class="mt-2"
            text
          >
            <v-icon left>mdi-crown</v-icon>
            Painel Ultimate
          </v-btn>
        </div>

        <v-divider></v-divider>
      </div>

      <vue-perfect-scrollbar
        :settings="{ suppressScrollX: true, wheelPropagation: false }"
        class="ps flex-grow-1"
        style="height: 100%"
      >
        <v-list class="py-0 mx-4" dense>
          <template v-for="(item, i) in menu">
            <div :key="item.subheader" v-if="item.subheader">
              <v-subheader>
                {{ item.subheader }}
              </v-subheader>

              <v-divider></v-divider>
            </div>

            <base-item-group-two
              v-if="item.children"
              :key="`group-${i}`"
              :item="item"
            >
            </base-item-group-two>

            <!-- <base-item-two
              v-else-if="!item.subheader"
              :key="`item-${i}`"
              :item="item"
            /> -->
          </template>
        </v-list>
      </vue-perfect-scrollbar>
    </div>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { appBarColor } from "@/themeConfig.js";
import adminMenu from "@/data/admin-menu.js";
import platformMenu from "@/data/platform-menu.js";

export default {
  data() {
    return {
      selectedItem: 0,
      group: null,
      showMenu: false,
      appBarColor,
      search: "",
    };
  },
  computed: {
    ...mapGetters(["getThemeMode"]),
    ...mapGetters("company", ["companies", "selectedCompany"]),
    ...mapGetters("auth", ["hasPermission", "hasUltimatePermission"]),
    menu() {
      const menu = adminMenu;
      return menu
        .map((i) => {
          return {
            ...i,
            children: i.children.filter((child) => {
              if (!child.permission) return true;
              return this.hasPermission(child.permission);
            }),
          };
        })
        .filter((i) => i.children.length);
    },
    companiesFiltered() {
      const response = [];
      response.push(
        ...this.companies.filter((item) => item.id != this.selectedCompany?.id)
      );
      return response;
    },
    show() {
      let sidebar = this.getThemeMode.verticalSidebarDrawer;
      return sidebar;
    },
  },
  methods: {
    ...mapActions(["changeVerticalSidebarDrawer"]),
    ...mapActions("company", ["getAllCompanies", "selectCompany"]),
    toggleShow(v) {
      if (!v) this.changeVerticalSidebarDrawer(v);
    },
    selectComp(id) {
      this.selectCompany(id);
      this.showMenu = false;
    },
    adjustBrightness(hex, amount) {
      hex = hex.replace(/^#/, "");
      let r = parseInt(hex.substring(0, 2), 16) + amount;
      let g = parseInt(hex.substring(2, 4), 16) + amount;
      let b = parseInt(hex.substring(4, 6), 16) + amount;
      r = Math.max(Math.min(255, r), 0).toString(16);
      g = Math.max(Math.min(255, g), 0).toString(16);
      b = Math.max(Math.min(255, b), 0).toString(16);
      return `#${r.padStart(2, "0")}${g.padStart(2, "0")}${b.padStart(2, "0")}`;
    },
    goToUltimate() {
      this.selectCompany("_ultimate");
      this.$router.push({ name: "ultimate.index" });
    },
  },
  watch: {},
  mounted() {
    this.getAllCompanies();
  },
};
</script>
<style lang="scss">
.bg-sidebar-six {
  // background-color: #303133;
}
.theme--dark .v-navigation-drawer {
  .bg-sidebar-six {
    // background-color: #303133;
  }
}
.sidebar-six {
  .v-list-item__icon {
    margin-right: 8px !important;
    // margin-bottom: 0;
    // margin-top: 0;
  }

  .v-list-item--link:before {
    border-radius: 8px;
  }
}
</style>
